import { render, staticRenderFns } from "./CompanyLegalRegulationsListComponent.vue?vue&type=template&id=71eb01f4&"
import script from "./CompanyLegalRegulationsListComponent.vue?vue&type=script&lang=js&"
export * from "./CompanyLegalRegulationsListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports